import React, { FC } from "react";
import QuestionBox from "./QuestionBox";
import Input from "components/semantic/Input";

interface ContactAdminProps {
  questions: any;
  padding: string;
  formProps: any;
}

const ContactAdmin: FC<ContactAdminProps> = ({ questions, padding, formProps }) => {
  const { values, setFieldValue, initialValues } = formProps;

  return (
    <div className="md:border md:rounded-lg md:mx-5 md:-mt-0.5 md:mb-4">
      <QuestionBox question={questions?.Question} SNo={questions?.S_No} formProps={formProps} Id={questions?.Id} />
      {questions?.SubQuestion && (
        <div className={`bg-[#F4F5FA] ${padding} ${(values["POLYFYX_QC3"] === false && questions?.Id === "POLYFYX_QC3") || (questions?.Id !== "POLYFYX_QC3" && values[questions?.Id]) || questions?.Id === "POLYFYX_QC4" ? "slide-down" : "slide-up"} md:rounded-b-lg`}>
          {questions?.SubQuestion.map((subQuestions: any, i: number) => {
            if (subQuestions?.QuestionType === "Custom") {
              return (
                <div key={i} className="w-full py-2 border-b border-border-color">
                  <p className="font-bold text-sm min-w-72 ">{subQuestions?.Question}</p>
                  {subQuestions?.Fields &&
                    subQuestions?.Fields.map((customFields: any, customIndex: number) => {
                      return <Input key={customIndex} limit={subQuestions.Id === "POLYFYX_QC3_1" ? 11 : undefined} name={customFields?.Name} label={customFields?.Name} placeholder={customFields.Name} value={values?.[subQuestions?.Id]?.[customFields?.Id]} onChange={(e) => setFieldValue(`${subQuestions?.Id}.${customFields?.Id}`, e.target.value)} />;
                    })}
                </div>
              );
            } else if (subQuestions?.QuestionType === "Custom_Multiple") {
              return (
                <div key={i} className="w-full relative bg-[#FEFFE8] border-[3px] border-[#E3E5C3] grid grid-cols-1 gap-y-2 md:gap-y-0 md:grid-cols-2 rounded-[10px] py-3 px-5">
                  <div className="absolute -left-2 -top-2 border-2 border-[#E3E5C3] bg-white w-5 h-5 text-center ">
                    <p className="text-[11px] font-bold">{i + 1}</p>
                  </div>
                  {subQuestions?.Fields &&
                    subQuestions?.Fields.map((customFields: any, customFieldsIndex: number) => {
                      return (
                        <div className="text-sm font-bold w-full " key={customFieldsIndex}>
                          <p>{customFields?.Name}</p>
                          {values["POLYFYX_QC4"] ? <p className="text-sm font-medium text-[#000000CC]">{initialValues[subQuestions?.Id]?.[i]?.[customFields?.Id]}</p> : <Input className="max-w-full  md:max-w-[90%]" key={customFieldsIndex} name={customFields.Name} placeholder={customFields.Name} value={values[subQuestions?.Id]?.[i]?.[customFields?.Id]} onChange={(e) => setFieldValue(`${subQuestions?.Id}.${[i]}.${customFields?.Id}`, e.target.value)} />}
                        </div>
                      );
                    })}
                </div>
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

export default ContactAdmin;
